export default (e, value) => (
  {
    ...e,
    target: {
      ...e.target,
      value,
      name: e.target.name,
    },
  }
);
